<div class="lock-listing">
  <ng-container>
    <div class="scroll-container">
      <div class="overflow-y">
        <ng-container
          *ngFor="
            let device of deviceList | sortBy : 'deviceName' : 'asc';
            let i = index
          "
        >
          <div class="mb-2 px-1">
            <div
              class="row-padding d-flex align-items-start pt-3 pb-3"
              [ngClass]="{
                'device-list': device?.deviceState === CONSTANTS.OFFLINE
              }"
            >
              <div class="lock-icon-center text-center col-1">
                <img
                  alt="User Icon"
                  [src]="device?.deviceState | deviceLockImage"
                  class="height-40 width-40"
                />
              </div>
              <div class="d-flex flex-column col-7 justify-content-center">
                <div class="tab-heading">
                  <app-with-tooltip [showHelpCursor]="true">
                    {{ device?.deviceName }}
                  </app-with-tooltip>
                </div>

                <span class="tab-date">
                  <b>
                    <app-with-tooltip [showHelpCursor]="true">
                      {{ 'SERIAL_NUMBER_HASH' | translate }}
                      {{ device?.deviceId }}
                    </app-with-tooltip></b
                  >
                </span>
              </div>
              <div class="filter-icon-margin pt-2 pointer-cursor col-4">
                <div class="d-flex flex-row justify-content-end pr-3">
                  <img class="ml-2 pr-1" src="assets/svg/ico-menu-button.svg" />
                </div>
              </div>
            </div>
            <ng-container *ngIf="device?.deviceState === CONSTANTS.OFFLINE">
              <div class="px-3 pt-2 pb-2 d-flex floor-installation">
                <div class="pr-3 pl-1 align-self-center">
                  <img
                    alt="User Icon"
                    src="assets/svg/ico-lock-warning-outline-white.svg"
                  />
                </div>
                <div>
                  {{ 'YOUR_CONTROLLER_IS_OFFLINE' | translate }}
                </div>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>
